export const Ethnicities = [
  {
    name: 'White',
    value: 'white',
  },
  {
    name: 'White and Black Caribbean',
    value: 'white_black_caribbean',
  },
  {
    name: 'White and Black African',
    value: 'white_black_african',
  },
  {
    name: 'White and Asian',
    value: 'white_asian',
  },
  {
    name: 'Any other Mixed/Multiple ethnic background',
    value: 'mixed',
  },
  {
    name: 'Asian - Indian',
    value: 'asian_indian',
  },
  {
    name: 'Asian - Pakistani',
    value: 'asian_pakistani',
  },
  {
    name: 'Asian - Bangladeshi',
    value: 'asian_bangladeshi',
  },
  {
    name: 'Asian - Chinese',
    value: 'asian_chinese',
  },
  {
    name: 'Asian - Any other Asian background',
    value: 'asian_other',
  },
  {
    name: 'African',
    value: 'african',
  },
  {
    name: 'Caribbean',
    value: 'caribbean',
  },
  {
    name: 'Any other Black / African / Caribbean background',
    value: 'black_african_caribbean_other',
  },
  {
    name: 'Arab',
    value: 'arab',
  },
  {
    name: 'Any other ethnic group',
    value: 'other',
  },
];

export default Ethnicities;
